export default {
  DJToJS: {
    /**
     * @typedef {Object} attendanceDJ
     * @property {Boolean} is_completed
     * @property {Boolean} is_discarded
     * @property {Date} completed_at
     *
     * @typedef {Object} ResourceDJ
     * @property {String} id - Identifiant de la ressource
     * @property {attendanceDJ|null} attendance - suivi de la ressource pour l'utilisateur courant
     * @property {String} title - Titre de la ressource
     * @property {String} description - Description de la ressource
     * @property {String} languages - List des langues de la ressource
     * @property {String} format - Format de la ressource
     * @property {String} nature - Nature de la ressource
     * @property {String} level - Difficulté de la ressource
     * @property {String} duration - Durée estimée de la ressource format HH:MM:SS
     * @property {Date} publication_date - Date de publication
     * @property {String} author - Auteur de la ressource
     * @property {String} link - Lien vers la ressource
     * @property {String} image - Lien vers l'image de représentant la ressource
     * @property {String} icon - Nom de la classe de l'icone représentant la nature la ressource
     * @property {Boolean} is_active - Determine l'accessibilité de la ressource
     *
     * @param {ResourceDJ} resourceDJ
     * @returns {ResourceAir}
     */
    convertResource (resourceDJ) {
      let {
        publication_date: publicationDate,
        is_active: isActive,
        attendance,
        ...resourceCore
      } = resourceDJ
      publicationDate = Date.parse(publicationDate)
      return {
        ...resourceCore,
        publicationDate,
        isActive,
        attendance: !attendance ? null : {
          isCompleted: attendance.is_completed,
          isDiscarded: attendance.is_discarded,
          completionDate: !attendance.completed_at
            ? null : Date.parse(attendance.completed_at)
        }
      }
    }
  }
}
